import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { getFaqList } from "../../../service/cms/cms";
import { useTranslation } from "react-i18next";

const ConfigurationFaq = () => {

  const APP_URL = process.env.REACT_APP_URL;

  const { t } = useTranslation();
  const [faqList, setFaqList] = useState([]);
  const _GET_FAQ_LIST = async () => {
    getFaqList("CONFIGURE")
      .then((res) => {
        setFaqList(res?.data?.data);
      //  console.log(res.data.data, "resData");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    _GET_FAQ_LIST();
  }, []);
  const [activeIndex, setActiveIndex] = useState(0);

  const onTitleClick = useCallback(
    (index) => {
      setActiveIndex(index === activeIndex ? null : index);
    },
    [activeIndex]
  );

  return (
    <div className="container-fluid">
      <div className="dbMain configFaqBg">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header link="#" breadcm="" title={t("faqs")} description="" />
          <div className="commonBase">
            <div className="aboutBase">
              <div className="accordion faqAccordion">
                {faqList.map((item, index) => (
                  <div key={index} className="accordion-item">
                    <div
                      className={`accordion-title ${
                        index === activeIndex ? "active" : ""
                      }`}
                      onClick={() => onTitleClick(index)}
                    >
                      {item?.question}
                    </div>
                    {index === activeIndex && (
                      <div className="accordion-content">
                        <p>{item?.answer}</p>
                        {item?.faqImg && (
                          <img
                            src={`${APP_URL}/uploads/customer/${item?.faqImg}`}
                            alt=""
                            width={50}
                            height={50}
                          />
                        )}
                        {item?.faqVideo && (
                          <video width="320" height="240" controls>
                            <source
                              src={`${APP_URL}/uploads/customer/${item?.faqVideo}`}
                              type="video/mp4"
                            />
                            {t("no_video_support")}
                          </video>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationFaq;
